import moment from 'moment';
import { DateFormat } from '../constants/dateFormat';

// helper method for formatting date
export const ShortDateStringForUser = (date: Date | string, dateSettingId: number) => {
  let format: string;
  switch (dateSettingId) {
      case DateFormat.MonthDayYear:
          format = "MM/DD/YYYY";
          break;
      case DateFormat.DayMonthYear:
          format = "DD/MM/YYYY";
          break;
      case DateFormat.YearMonthDay:
          format = "YYYY-MM-DD";
          break;
      default:
          format = "MM/DD/YYYY";
          break;
  }
  return moment(date).format(format);
}

export const UTCNow = () => {
    var date = new Date(); 
    var now_utc =  Date.UTC(date.getUTCFullYear(), date.getUTCMonth(), date.getUTCDate(),
    date.getUTCHours(), date.getUTCMinutes(), date.getUTCSeconds());
    let utc = new Date(now_utc);
    return utc
}

export const TimeWithTimeZone = (date: Date) => {
    return moment(date).format("h:mma")
}

export const TimeFromDate = (date: Date) => {
    return moment(date).format("h:mm A")
}

export const LongDateStringForUser = (date: any, dateSettingId: number) => {
  return ShortDateStringForUser(date, dateSettingId) + moment(date).format(" h:mm A");
}

export const SignatureExpireDateStringForUser = (date: Date, dateSettingId: number) => {
    return ShortDateStringForUser(date, dateSettingId) + moment(date).format(" h a");
}

export const GetDateFormateStr = (dateSettingId: number)  => {
    let format: string;
    switch (dateSettingId) {
        case DateFormat.MonthDayYear:
            format = "MM/DD/YYYY";
            break;
        case DateFormat.DayMonthYear:
            format = "DD/MM/YYYY";
            break;
        case DateFormat.YearMonthDay:
            format = "YYYY-MM-DD";
            break;
        default:
            format = "MM/DD/YYYY";
            break;
    }
    return format;
}

export const ShortWrittenOutDateString = (date: Date, dateSettingId: number) => {
    let format: string;
    switch (dateSettingId) {
        case DateFormat.MonthDayYear:
            format = "MMMM DD, yyyy";
            break;
        case DateFormat.DayMonthYear:
            format = "DD MMMM, yyyy";
            break;
        case DateFormat.YearMonthDay:
            format = "yyyy MMMM DD";
            break;
        default:
            format = "MMMM DD, yyyy";
            break;
    }
    return moment(date).format(format);
} 

export const AddDays = (date: Date, days: number) => {
  var result = new Date(date);
  result.setDate(result.getDate() + days);
  return result;
}

export const DateRangeOverlaps = (a_start: Date, a_end: Date, b_start: Date, b_end: Date) => {
    if (a_start <= b_start && b_start < a_end) return true; // b starts in a
    if (a_start < b_end   && b_end   <= a_end) return true; // b ends in a
    if (b_start <  a_start && a_end   <  b_end) return true; // a in b
    return false;
}

export const getD3VisxTimeFormat = (dateSettingId: number) => {
    switch (dateSettingId) {
        case DateFormat.MonthDayYear:
            return "%m/%d/%Y";
        case DateFormat.DayMonthYear:
            return "%d/%m/%Y";
        case DateFormat.YearMonthDay:
            return "%Y-%m-%d";
        default:
            return "%m/%d/%Y";
    }
}